export enum QuestionnaireStatus {
  REQUESTED = 'REQUESTED',
  CANCELED = 'CANCELED',
  SKIPPED = 'SKIPPED',
  FILLED = 'FILLED',
}
